(ns teamoesterreich.admin-mode.event.detail.event-admin
  (:require [clojure.string]
            [reagent-material-ui.components :as mui]
            [goog.date.DateTime]
            [reagent.core :as r]
            [teamoesterreich.util.log :as log]
            [teamoesterreich.util.helper :as h]
            [teamoesterreich.util.date :as h-date]
            [teamoesterreich.view-state :as store]
            [reagent-material-ui.components :as mui]
            [reagent.core :as r]
            [teamoesterreich.admin-mode.data.event :as d-event]
            [teamoesterreich.admin-mode.data.rights :as d-rights]
            [teamoesterreich.admin-mode.component.ws-event-sync-component :as ws-event-sync-component]
            [teamoesterreich.admin-mode.modal.toe-info :as toe-modal]
            [teamoesterreich.admin-mode.modal.toe-search :as toe-search]

            [reagent-material-ui.icons.add :refer [add]]
            [reagent-material-ui.icons.info :refer [info]]
            [reagent-material-ui.icons.send :refer [send]]
            [reagent-material-ui.icons.delete-forever :refer [delete-forever]]
            ))


(defn get-it []
  (let [!st (r/atom {:logs nil :loaded false :tomId nil})
        !tomId (r/cursor !st [:tomId])
        !event (r/cursor store/app-state [:selected-event])
        !event-detail-loaded? (r/cursor store/app-state [:event-detail-loaded])
        !event-uuid (r/cursor !st [:event-uuid])
        !logs (r/cursor !st [:logs])
        !show-add-admin-modal (r/cursor !st [:show-add-admin-modal])
        !loaded (r/cursor !st [:loaded])]

    (fn []
      (let [event-uuid (:crowdtaskerEvent-uuid @!event)
            event-admins (or (:crowdtaskerEvent-admins @!event) [])]

        (when-not @!event-detail-loaded?
          (d-event/<event-load (:crowdtaskerEvent-uuid @!event)
                               (fn [response]
                                 (reset! !event response)
                                 (reset! !event-detail-loaded? true)
                                 )))

        [mui/grid {:container true
                   :direction "row" :justify "flex-start" :alignItems "flex-start"}
         [mui/grid {:item true :xs 4}
          (when (d-rights/allow-admin-for d-rights/CLASSIC_ACTIVATE)
            [mui/button {:variant   "outlined" :color "primary"
                         :startIcon (r/as-element [add])
                         :onClick   #(reset! !show-add-admin-modal true)
                         :style     {:marginRight "10px"}}
             "Neuer Registrierer"])
          ]
         [mui/grid {:item true :xs 4}
          [:h3 "Einsatz Registrierer"]
          [toe-modal/get-modal !tomId]
          [toe-search/get-modal
           !show-add-admin-modal
           (fn [tom-id]
             (println "selected tom-id" tom-id)
             (d-event/>event-add-admin (:crowdtaskerEvent-uuid @!event) tom-id #(reset! !event-detail-loaded? nil)))
           ]]


         [mui/grid {:item true :xs 12 :md 8 :lg 6 }
          (log/debug "Logs " (not (true? @!loaded)) (not= @!event-uuid event-uuid) (clj->js event-admins))
          ;is loaded
          [mui/card {:style {:textAlign "left" :marginTop "10px"}}
           [mui/card-content
            [mui/table
             [mui/table-head
              [mui/table-row
               [mui/table-cell "TomId"]
               [mui/table-cell "Name"]
               [mui/table-cell "Verantwortlich"]
               ]]

             [mui/table-body
              (for [{:keys [user-uuid user-tomId user-lastName user-firstName]} (sort-by :user-lastName event-admins)]
                ^{:key (str "admin-" user-uuid)}
                [mui/table-row
                 [mui/table-cell [mui/icon-button {:label   "Info"
                                                   :onClick #(reset! !tomId 53177)
                                                   } [info {:fontSize ""}]]
                  user-tomId]
                 [mui/table-cell user-firstName " " user-lastName]
                 [mui/table-cell
                  ;[mui/icon-button {:label "senden"
                  ;                  } [send {:fontSize ""}]]
                  [mui/icon-button {:label   "löschen"
                                    :onClick #(d-event/>event-remove-admin (:crowdtaskerEvent-uuid @!event) user-tomId (fn [_] nil))
                                    } [delete-forever {:fontSize ""}]]]
                 ])
              ]
             ]
            ]
           ]
          ]]
        ))
    ))






































